export const GET_PRODUCT_DATA_REQ = "GETPRODUCTDATAREQ";
export const GET_PRODUCT_DATA_SUCCESS = "GETPRODUCTDATASUCCESS";
export const GET_PRODUCT_FAILURE = "GETPRODUCTFAILURE";

export const GET_URL_REQ = "GETURLREQ";
export const GET_URL_SUCCESS = "GETURLSUCCESS";
export const GET_URL_FAILURE = "GETURLFAILURE";

export const GET_SINGLE_PR_REQ = "GETSINGLEPRREQ";
export const GET_SINGLE_PR_SUCCESS = "GETSINGLEPRSUCCESS";
export const GET_SINGLE_PR_FAILURE = "GETSINGLEPRFAILURE";
